/**
 * Public tracking IDs. Prefer env/siteMetadata when set; fall back to known site IDs
 * so production still works if Netlify env is missing FB_PIXEL_ID.
 */
export const TRACKING_IDS = {
  //   gaAnalyticsId: "UA-191706269-1",
  gaAnalyticsId: "G-S7SXM2LY0K",
  fbPixelId: "1224042156214507",
};

export const resolveTrackingIds = (siteMetadata = {}) => ({
  gaAnalyticsId:
    siteMetadata.gaAnalyticsId ||
    process.env.GA_ANALYTICS_ID ||
    TRACKING_IDS.gaAnalyticsId,
  fbPixelId:
    siteMetadata.fbPixelId || process.env.FB_PIXEL_ID || TRACKING_IDS.fbPixelId,
});
